<template>
  <div>
    <blockquote
      v-if="!nodos.length"
      class="quote quote-assets-primary quote-first"
    >
      <p>
        <span>
          {{ $t('mEditionAssetActivation.quote.firstText') }}
          {{ $t('mEditionAssetActivation.quote.secondText') }}
          <router-link
            :to="`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.contents.subject')}`"
            class="text-color-assets-primary"
          >
            {{ $t('mEditionMenu.asset.contents.text') }}.
          </router-link>
        </span>
      </p>
    </blockquote>

    <MoleculeEditionAssetActivationCalendar
      v-if="element.fecha_inicio"
      key="activationCalendar"
      :element="element"
    />
    <MoleculeEditionAssetActivationInmediate
      v-if="!element.fecha_inicio && nodos.length"
      key="activationInmediate"
      :element="element"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetActivationActivate',

  components: {
    MoleculeEditionAssetActivationCalendar: () => import('@/components/molecules/MoleculeEditionAssetActivationCalendar'),
    MoleculeEditionAssetActivationInmediate: () => import('@/components/molecules/MoleculeEditionAssetActivationInmediate')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  computed: {
    nodos () {
      return [...this.$store.getters.getAssetNodes]
    }
  }
}
</script>
